import React, {useMemo} from "react";
import PSPage from "components/globals/ui/layout/Page"
import {ORSMasterListing} from "components/globals/ORSMasterListing"
import desktop1 from "assets/images/carousel/desktop/1.jpg";
import e38desktop from "assets/images/carousel/desktop/2.jpg";
import mobile1 from "assets/images/carousel/mobile/1.jpg";
import e38mobile from "assets/images/carousel/mobile/2.jpg";
import drive from "assets/images/carousel/desktop/3.jpg";
import driveMobile from "assets/images/carousel/mobile/3.jpg";
import MarketingGallery from "components/globals/image/MarketingGallery";
import { useAuth } from 'providers/AuthContext';
import { useNavigate } from "react-router-dom";
import { useEffect } from 'react';
import { FaDiscord } from "react-icons/fa6";
import ORSBanner from "components/globals/ORSBanner";

export default function Home() {
const { userInfo, isFetching } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {

    if (!isFetching) {
      if (!userInfo || !userInfo.username) {
        navigate("/welcome");
      }
    }
  }, [userInfo, isFetching, navigate]);

  const sections = useMemo(() => {
    if (!userInfo?.username) return [];

    return [
      { 
        params: {
          elementId: "newFollowerPosts", 
          headingTitle: "Posts from users you follow",
          shortTitle: "Posts from Following",
          headingButtonUrl: "",
          headingButtonText: "",
          apiPath: `post/type/all/following/${userInfo.username}`,
          omit: "none",
          limit: "24",
          type: "post", 
          pagination: true,
        },
        displayOptions: {
          layout: "card",
          yoursBadge: true,
          userBadge: true,
          typeBadge: true,
          categoryBadge: true,
          carBadge: true,
          carDetails: true,
          dateDetails: true,
          rowColumns: true,
          mobileCarousel: false,
          likes: true,
        }
      },
      { 
        params: {
          elementId: "newPosts", 
          headingTitle: "Recent User Posts",
          shortTitle: "Posts",
          headingButtonUrl: "/posts",
          headingButtonText: "View All",
          apiPath: "post/type/all",
          omit: "none",
          limit: "24",
          type: "post", 
          pagination: true,
        },
        displayOptions: {
          layout: "card",
          yoursBadge: true,
          userBadge: true,
          typeBadge: true,
          categoryBadge: true,
          carBadge: true,
          carDetails: true,
          dateDetails: true,
          rowColumns: true,
          mobileCarousel: false,
          likes: true,
        }
      },
      { 
        params: {
          elementId: "newCars", 
          headingTitle: "Recent User Cars",
          shortTitle: "Cars",
          headingButtonUrl: "/cars/all",
          headingButtonText: "View All",
          apiPath: "garage",
          omit: "none",
          limit: "6",
          type: "car", 
          pagination: false,
        },
        displayOptions: {
          layout: "card",
          yoursBadge: true,
          typeBadge: false,
          categoryBadge: true,
          userBadge: true,
          carBadge: true,
          carDetails: true,
          dateDetails: false,
          rowColumns: true,
          mobileCarousel: false,
          likes: true,
        }
      },
      { 
        params: {
          elementId: "newUsers", 
          headingTitle: "Recent Users",
          shortTitle: "Users",
          headingButtonUrl: "/society/members",
          headingButtonText: "View All",
          apiPath: "users",
          omit: "none",
          limit: "6",
          type: "user", 
          pagination: false,
        },
        displayOptions: {
          layout: "row",
          yoursBadge: false,
          typeBadge: false,
          categoryBadge: false,
          userBadge: false,
          carBadge: false,
          carDetails: false,
          dateDetails: false,
          rowColumns: true,
          mobileCarousel: false,
          likes: true,
        }
      },
      // { 
      //   params: {
      //     elementId: "newGroups", 
      //     headingTitle: "Recent Groups",
      //     shortTitle: "Groups",
      //     headingButtonUrl: "/groups/all",
      //     headingButtonText: "View All",
      //     apiPath: "group",
      //     omit: "none",
      //     limit: "6",
      //     type: "group", 
      //     pagination: false,
      //   },
      //   displayOptions: {
      //     layout: "card",
      //     yoursBadge: true,
      //     typeBadge: false,
      //     categoryBadge: false,
      //     userBadge: true,
      //     carBadge: true,
      //     carDetails: true,
      //     dateDetails: false,
      //     rowColumns: true,
      //     mobileCarousel: false,
      //     likes: true,
      //   }
      // },
    ];
  }, [userInfo]);
  const carousel = [
    {
      image: drive,
      mobileImage: driveMobile,
      title: "Inaugural Drive",
      description: "Our first drive to celebrate the launch of the site.",
      btnText: "Read Article",
      url: "/article/cee1312203764632929e622495e40a0a",
      textColor: "white",
    },
    {
      image: e38desktop,
      mobileImage: e38mobile,
      title: "Understated Perfection",
      description: "2000 BMW E38",
      btnText: "Read Article",
      url: "/article/db48bf7856f446f9850c3dcfb3b48cc7",
      textColor: "white",
    },
    {
      image: desktop1,
      mobileImage: mobile1,
      title: "Welcome!",
      description: "Site launch April 2025",
      btnText: "Read More",
      url: "/article/38bd8c72c2d24cc587d3b4c37c270c8e",
      textColor: "black",
    }
  ]
    

  return (
    <>
      <ORSBanner link="https://discord.gg/dt6Uu7zz">
        <div className="flex items-center">
          <FaDiscord className="mr-2" />
          <p>We have a discord server now, join here!</p>
        </div>
      </ORSBanner>
      <MarketingGallery slides={carousel} />
      <PSPage>

        {/* <div className="my-sm p-xs sm:p-sm bg-[#ffffff] rounded-lg">
          <div className="ors-rich-text mb-sm full">
            <h3 className="!mt-0">Private Beta</h3>
            <p>
              Since the site is currently in active development, 
              there will be a lot of changes and updates happening 
              frequently. If you notice anything out of place,  
              please <a href="mailto:mattaebersold@gmail.com">reach out to us</a>.
            </p>

            <p>
              Take a look at these pages frequently, as they will have the 
              most up-to-date changes and notes on what's coming up.
            </p>
          </div>

          <div className="mb-sm">
            <ORSVersion />
          </div>

          <ORSGridLinks>
            <ORSGridLink link="/roadmap" bg="tangerine" text="Roadmap" />
            <ORSGridLink link="/changelog" bg="speed" text="Changelog" />
          </ORSGridLinks>
        </div> */}

        {!isFetching && userInfo?.username && (
          <>
            {sections.map(({ params, displayOptions }) => (
              <ORSMasterListing key={params.elementId} params={params} displayOptions={displayOptions} />
            ))}
          </>
        )}
      </PSPage>
    </>
  );
}
